import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Inbox } from "lucide-react";
import { statsApi } from "../lib/api";

export const UnusedSlotsTile = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    statsApi.get().then((s) => {
      if (alive) setCount(s?.unused ?? 0);
    }).catch(() => {
      if (alive) setCount(0);
    });
    return () => { alive = false; };
  }, []);

  const display = count ?? 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="unused-slots-tile"
      className="relative tup-card p-3 text-left border-dashed border-[#C9C4B5] bg-gradient-to-br from-white to-[#F2F7F3] overflow-hidden flex flex-col items-center justify-center text-center"
    >
      <Inbox className="w-7 h-7 text-[#4A8A78] opacity-70" />
      <div
        className="font-heading text-3xl font-extrabold text-[#2D3142] mt-1 leading-none"
        data-testid="unused-slots-count"
      >
        {display}
      </div>
      <div className="text-[10px] font-bold uppercase tracking-wider text-[#4A8A78] mt-1">
        Unused
      </div>
      <div className="text-[10px] text-[#4F5D75] mt-1 leading-snug">
        {display === 1 ? "container ready to refill" : "containers ready to refill"}
      </div>
    </motion.div>
  );
};
